import { Atom } from './Atom';
import { callbacksMap } from './callbacksMap';
var createAtom = function (initialValue) {
    return new Atom(initialValue, callbacksMap);
};
export { createAtom };
